import {EventType, MatrixEvent} from 'matrix-js-sdk';

export const isNameChangeEvent = (e: MatrixEvent): boolean => {
  if (e.getType() === EventType.RoomMember) {
    const prevContent = e.getPrevContent();
    const content = e.getContent();
    if (prevContent.membership === 'join' && content.membership === 'join') {
      if (prevContent.displayname && content.displayname) {
        return prevContent.displayname !== content.displayname;
      }
    }
  }
  return false;
};
